import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface IEditPostMediaItem {
  _id: string;
  url: string;
  urlLarge?: string;
  urlMedium?: string;
  type: 'image' | 'video';
}

export interface IEditPostUser {
  _id: string;
  displayName: string;
  userName: string;
  profileImage: { urlSmall?: string } | null;
  collabStatus?: 'ACCEPTED' | 'PENDING' | 'DECLINED';
}

export interface IEditPostRequest {
  postId: string;
  caption: string;
  backgroundPattern?: string;
  backgroundBg?: string;
  location?: string;
  audience?: string;
  hashtags?: string[];
  existingMedia?: IEditPostMediaItem[];
  taggedPeople?: IEditPostUser[];
  collaborators?: IEditPostUser[];
}

@Injectable({ providedIn: 'root' })
export class EditPostService {
  private editRequest$ = new Subject<IEditPostRequest>();
  readonly onEditRequest$ = this.editRequest$.asObservable();

  openEditModal(req: IEditPostRequest): void {
    this.editRequest$.next(req);
  }
}